var map = {
	"./origial/mainlogo.svg": "oljn",
	"./origial/mainlogo_HSMES.svg": "5aSB",
	"./svg/badge.svg": "52Ne",
	"./svg/buttonanalyze.svg": "WWyE",
	"./svg/buttonbackground.svg": "Q6og",
	"./svg/buttoncost.svg": "VyTW",
	"./svg/buttonstatement.svg": "Q+Cn",
	"./svg/buttonstatistics.svg": "JKYT",
	"./svg/close.svg": "toIl",
	"./svg/list.svg": "vuHp",
	"./svg/loginlogo.svg": "dX4d",
	"./svg/loginuser.svg": "kZvo",
	"./svg/password.svg": "QjmH",
	"./svg/television.svg": "1ePl",
	"./svg/user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i+SB";


//////////////////
// WEBPACK FOOTER
// ./src/icons \.svg$
// module id = i+SB
// module chunks = 9